// Shared mock data — services, pricing, testimonials, specialists

export const CATEGORIES = [
  {
    id: "hair",
    label: "Hair",
    tag: "01",
    description:
      "Tunsori contemporane, vopsit avansat și tratamente capilare premium pentru un păr cu strălucire de revistă.",
    image:
      "https://images.pexels.com/photos/13714796/pexels-photo-13714796.jpeg",
  },
  {
    id: "unghii",
    label: "Unghii",
    tag: "02",
    description:
      "Manichiură și pedichiură executate cu rigoare, gel de lungă durată și nail art editorial.",
    image:
      "https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtYW5pY3VyZSUyMG5haWxzJTIwcG9saXNofGVufDB8fHx8MTc4MjI5OTUwNXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "fata",
    label: "Față",
    tag: "03",
    description:
      "Ritualuri faciale rafinate — curățare profundă, hidratare intensă și protocoale anti-aging.",
    image:
      "https://images.pexels.com/photos/3997989/pexels-photo-3997989.jpeg",
  },
  {
    id: "machiaj",
    label: "Machiaj & Sprâncene",
    tag: "04",
    description:
      "Machiaj editorial, look-uri pentru mireasă și design de sprâncene perfect arcuit.",
    image:
      "https://images.pexels.com/photos/6144292/pexels-photo-6144292.jpeg",
  },
];

export const SERVICES = {
  hair: [
    { name: "Tuns dame", duration: "45 min", price: 80, desc: "Tăietură personalizată, finisaj cu styling." },
    { name: "Tuns bărbați", duration: "30 min", price: 60, desc: "Foarfecă & mașină, conturare exactă a liniilor." },
    { name: "Vopsit balayage", duration: "180 min", price: 350, desc: "Tehnică franțuzească, treceri naturale de culoare." },
    { name: "Vopsit ombré", duration: "150 min", price: 320, desc: "Tranziție rafinată de la rădăcină la vârf." },
    { name: "Highlights / Șuvițe", duration: "150 min", price: 290, desc: "Lumini fine pentru un finisaj editorial." },
    { name: "Coafat ocazie", duration: "60 min", price: 130, desc: "Coc, valuri sau styling sculptural." },
    { name: "Tratament keratină", duration: "120 min", price: 280, desc: "Reparare și luciu intens pentru păr stresat." },
  ],
  unghii: [
    { name: "Manichiură clasică", duration: "40 min", price: 70, desc: "Îngrijire completă, pilire și lac fin." },
    { name: "Manichiură gel", duration: "60 min", price: 120, desc: "Finisaj de lungă durată, rezistent săptămâni." },
    { name: "Pedichiură clasică", duration: "50 min", price: 90, desc: "Exfoliere, masaj și relaxare." },
    { name: "Pedichiură gel", duration: "70 min", price: 140, desc: "Strălucire impecabilă, rezistență premium." },
    { name: "Nail art (per unghie)", duration: "10 min", price: 15, desc: "Detaliu artistic — French, foiță sau micro-art." },
  ],
  fata: [
    { name: "Curățare profundă", duration: "75 min", price: 220, desc: "Extracții fine, vapozonare, calmare." },
    { name: "Tratament hidratant", duration: "60 min", price: 200, desc: "Acid hialuronic și mască de fermitate." },
    { name: "Tratament anti-aging", duration: "90 min", price: 320, desc: "Peptide, masaj liftant și ser concentrat." },
    { name: "Peeling chimic", duration: "45 min", price: 280, desc: "Reînnoire celulară pentru un ten uniform." },
  ],
  machiaj: [
    { name: "Machiaj de zi", duration: "45 min", price: 180, desc: "Look natural luminos, finisaj „no-makeup”." },
    { name: "Machiaj de seară", duration: "60 min", price: 240, desc: "Smokey, contur și gene aplicate fir cu fir." },
    { name: "Machiaj mireasă", duration: "90 min", price: 450, desc: "Probă inclusă, rezistență 12+ ore." },
    { name: "Laminare sprâncene", duration: "45 min", price: 160, desc: "Fixare, formă perfectă și densitate vizibilă." },
    { name: "Microblading", duration: "120 min", price: 600, desc: "Tehnică fir cu fir, retuș inclus la 4 săptămâni." },
  ],
};

export const PACKAGES = [
  {
    name: "Pachet Mireasă",
    items: ["Probă machiaj & coafură", "Machiaj mireasă", "Coafat ocazie", "Manichiură gel"],
    total: 820,
    saved: 100,
    accent: true,
  },
  {
    name: "Pachet Relaxare",
    items: ["Tratament hidratant", "Manichiură clasică", "Pedichiură clasică"],
    total: 320,
    saved: 60,
  },
  {
    name: "Pachet Unghii Complete",
    items: ["Manichiură gel", "Pedichiură gel", "Nail art (5 unghii)"],
    total: 280,
    saved: 55,
  },
];

export const SPECIALISTS = [
  "Orice specialist",
  "Andreea Pop",
  "Cristina Mureșan",
  "Bianca Ilea",
];

export const TESTIMONIALS = [
  {
    quote:
      "Atmosfera te face să simți că ești într-o revistă de modă. Detaliile contează — de la cafeaua oferită la felul cum lucrează specialiștii. Pur și simplu impecabil.",
    name: "Andreea M.",
    location: "Cluj-Napoca",
    stars: 5,
  },
  {
    quote:
      "Am venit pentru o probă de mireasă și m-am întors pentru tot. Echipa Lumière înțelege exact ce înseamnă luxul liniștit.",
    name: "Ioana D.",
    location: "Cluj-Napoca",
    stars: 5,
  },
  {
    quote:
      "Cel mai bun balayage din oraș. Culoarea arată natural săptămâni întregi și textura părului a rămas perfectă.",
    name: "Maria T.",
    location: "Cluj-Napoca",
    stars: 5,
  },
];

export const FEATURED_QUOTE = {
  text:
    "Frumusețea nu se grăbește. Se cultivă, în liniște, în detalii — în felul cum lumina cade pe un păr proaspăt vopsit sau cum o sprânceană capătă forma perfectă.",
  author: "Elena V.",
  role: "Client Lumière din 2021",
};

export const CONTACT = {
  address: "Strada Eroilor 14, Cluj-Napoca",
  phone: "+40 264 123 456",
  email: "contact@lumierebeauty.ro",
  hours: "Luni–Sâmbătă: 09:00–20:00",
  hoursShort: ["Luni–Vineri · 09:00–20:00", "Sâmbătă · 09:00–18:00", "Duminică · Închis"],
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
};

export const HOURS_OPTIONS = (() => {
  const out = [];
  for (let h = 9; h <= 19; h++) {
    out.push(`${String(h).padStart(2, "0")}:00`);
    if (h < 19) out.push(`${String(h).padStart(2, "0")}:30`);
  }
  out.push("19:30");
  return Array.from(new Set(out));
})();
